import * as types from '../constants/actionTypes';

export default function runscript(state = {
    runscript :[]
    }, action) {
    switch (action.type) {

        case types.RUNSCRIPT__REQUESTED__SUCCEEDED: {
            return Object.assign({}, state, {
                runscript : action.payload
            });
        }


        case types.RUNSCRIPT__REQUESTED__FAILED: {
            if (action.payload.statusCode) {
                return Object.assign({}, state, {
                    runscript : action.payload
                });
            } else {
                return Object.assign({}, state, {
                    runscript : 'The request failed. Please check your network connection and try again.  ' +
                        'If this persists, please notify course staff.  Error: (' + action.payload +  ')'
                });
            }
        }

        case types.EXIT__OVERLAY__REQUESTED: {
            return Object.assign({}, state, {
                runscript : []
            });
        }

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/runscriptReducer.js
 **/